import {translate} from '../helpers';

const showOrderTplType = (deliverType: string, orderTplType: string) => {
  if (['EXPRESS_POST', 'POST'].includes(deliverType)) {
    return 'پست';
  }
  if (deliverType == 'CHAPAR') {
    return 'چاپار';
  }
  if (['VIP', 'VVIP'].includes(deliverType)) {
    return 'پیک اختصاصی';
  }
  if (!orderTplType || orderTplType == 'RONAD') {
    return 'پیک';
  }
  return translate(orderTplType, 'TPL');
};

export default showOrderTplType;
